import type { BaseClient } from '../../http/BaseClient.js';
import { unwrapData } from '../../common/envelope.js';
import type { UpdateUserRequest, UpdateUserResponse, UserProfile } from './types.js';

export class UserClient {
  constructor(private readonly http: BaseClient) {}

  async getProfile(): Promise<UserProfile> {
    const res = await this.http.get<{ success: boolean; data: UserProfile }>('/me');
    return unwrapData(res);
  }

  update(body: UpdateUserRequest): Promise<UpdateUserResponse> {
    return this.http.put<UpdateUserResponse>('/user', { body });
  }
}
